/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import axios from "axios";

// import NewContentList from "./NewContentList";

// import Event202104_contentList from "./Event202104_contentList";
// import parse from "html-react-parser";
//import '../../css/event20210317.css'
//import '../../css/event210521.css'
//import '../../css/event210629.css'
//import '../../css/event210819.css'
import '../../css/event211020.css';
// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import moment from "moment";
// import Slider from "react-slick";
// import { isMobile } from "react-device-detect";
import $ from 'jquery';
import axios from 'axios';
import fileDownload from 'js-file-download';

class Event202412_ak extends Component {
  state = {};
  componentDidMount = () => {
    this._getWindowSize();
  };
  _getWindowSize = () => {
    $('img[usemap]').rwdImageMaps();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  _onBack = () => {
    const { history } = this.props;

    history.goBack();
  };
  _down = () => {
    let url = 'https://www.aniplustv.com/download/doc.docx';
    let filename = '신청서.docx';
    axios
      .get(url, {
        responseType: 'blob',
      })
      .then((res) => {
        fileDownload(res.data, filename);
      });
  };

  render() {
    // const { bannerList, tabIndex, slideIndex } = this.state;

    return (
      <Fragment>
        <div className="event_head">
          <h3>번역 아카데미 1기 수강생 모집</h3>
          <button
            type="button"
            className="btnClose"
            onClick={this._onBack}
            style={{ pointer: 'cursor' }}
          >
            <img src="/img/detail_img/close_1.png" alt="닫기" />
          </button>
        </div>
        <div className="eventCon">
          <Fragment>
            <map name="Map2">
              <area
                target=""
                alt="다운로드"
                title="다운로드"
                // href="다운로드"
                coords="583,4028,1330,4196"
                shape="rect"
                onClick={this._down}
                style={{ cursor: 'pointer' }}
              />
            </map>

            <img src="/img/event/202412_ak/event202412_ak.png" useMap="#Map2" />
          </Fragment>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202412_ak));
